import React, { useId } from 'react';
import { resolveFieldPlaceholder } from '../utils/formPlaceholders';

const Input = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  helpText = '',
  error = '',
  required = false,
  disabled = false,
  icon: Icon = null,
  className = '',
  ...props
}) => {
  const fieldId = useId();
  const inputId = name || fieldId;
  const resolvedPlaceholder = resolveFieldPlaceholder({ placeholder, label, name, type });

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-bold text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative group">
        {Icon && (
          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 transition-colors">
            <Icon className={`w-5 h-5 ${error ? 'text-red-500' : 'text-gray-400 group-focus-within:text-red-500'}`} />
          </div>
        )}
        <input
          type={type}
          id={inputId}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={resolvedPlaceholder}
          disabled={disabled}
          required={required}
          className={`w-full px-4 py-3.5 border-2 rounded-2xl font-medium transition-all duration-300 
            ${Icon ? 'pl-12' : ''} 
            ${error 
              ? 'border-red-500 focus:border-red-600 focus:ring-4 focus:ring-red-500/20 bg-red-50/50' 
              : 'border-gray-200 hover:border-gray-300 focus:border-red-500 focus:ring-4 focus:ring-red-500/20'
            } 
            ${disabled 
              ? 'bg-gray-100 cursor-not-allowed text-gray-500' 
              : 'bg-white/50 backdrop-blur-sm text-gray-900 placeholder:text-gray-400 hover:bg-white'
            }
            focus:outline-none shadow-sm hover:shadow-md focus:shadow-xl focus:shadow-red-500/10`}
          {...props}
        />
      </div>
      {helpText && !error && (
        <p className="mt-1.5 text-xs text-gray-500">{helpText}</p>
      )}
      {error && (
        <p className="mt-2 text-sm text-red-600 font-medium flex items-center gap-1">
          <span className="inline-block w-1 h-1 bg-red-600 rounded-full"></span>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
